// extracted by extract-css-chunks-webpack-plugin
module.exports = {"linkButton":"_1GTLL2","button":"_1Yx8v-"};